import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-submit-enquiry',
  templateUrl: './submit-enquiry.component.html',
  styleUrls: ['./submit-enquiry.component.css']
})
export class SubmitEnquiryComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
